var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dropdown-menu" },
    [
      _c("ViewSetting", { attrs: { state: _vm.state } }),
      _vm._v(" "),
      _c("AlwaysShowOwnBoardsSetting", { attrs: { state: _vm.state } }),
      _vm._v(" "),
      _c("AdvancedUiSetting", { attrs: { state: _vm.state } }),
      _vm._v(" "),
      _c("LargePdfImageUiSetting", { attrs: { state: _vm.state } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }